const initializer = () => {

};

export const Cart = {
    init: () => initializer()
};




